import { useMutation, useQueryClient } from '@tanstack/react-query'
import { saveFarmMapping } from '../../services/farmMapping/saveFarmMapping'
import { queryKeys } from './queryKeys'

type SaveFarmMappingVariables = Parameters<typeof saveFarmMapping>[0]

export const useSaveFarmMapping = ({ farmId }: { farmId: string | undefined }) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (variables: SaveFarmMappingVariables) => saveFarmMapping(variables),
    // Most of the chain is plain creates, so a retry would duplicate the paddocks, subdivisions
    // and strata the first attempt already persisted.
    retry: 0,
    // This write runs inside the caller's processLoading wrapper, which already surfaces failures
    // through the loading modal — letting the global handler fire too would double-report.
    meta: { suppressGlobalError: true },
    // onSettled rather than onSuccess: the chain is fail-fast, so a rejection still leaves every
    // step before it persisted.
    onSettled: () =>
      Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.farm(farmId) }),
        queryClient.invalidateQueries({ queryKey: queryKeys.farms(), exact: true }),
        queryClient.invalidateQueries({ queryKey: queryKeys.paddocksByIdsRoot }),
      ]),
  })
}
